import { ApplicationLoadingService } from '@app/core/services/application-loading.service';
import { NotifierService } from 'angular-notifier';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { HttpClient } from '@angular/common/http';
import { BusinessConfig } from '../../../../common/business-config';

@Component({
  selector: 'app-terms-of-agreement',
  templateUrl: './terms-of-agreement.component.html',
  styleUrls: ['./terms-of-agreement.component.css']
})
export class TermsOfAgreementComponent implements OnInit {
  @Input() public email: string;
  @Output() public result: EventEmitter<any> = new EventEmitter();
  ipAddress: any = null;
  stripe_account_ID: string;

  companyName = BusinessConfig.COMPANY_NAME;

  constructor(
    private fun: AngularFireFunctions,
    private http: HttpClient,
    private notifierService: NotifierService,
    private applicationLoadingService: ApplicationLoadingService
  ) { }

  ngOnInit() {
  }

  async createAccount() {
    try {
      this.applicationLoadingService.toggleLoading(true);
      const ipData: any = await this.http.get<{ ip: string }>('https://jsonip.com').toPromise().catch(err => ({ error: err }));
      const ip = ipData.error == null ? ipData.ip : null;
      if (ip) {
        const res = await this.fun.httpsCallable('updateTos')({
          stripe_account_ID: this.stripe_account_ID,
          email: this.email,
          ipAddress: ip
        }).toPromise();
        this.result.emit(res);
        this.applicationLoadingService.toggleLoading(false);
      } else {
        this.applicationLoadingService.toggleLoading(false);
        this.notifierService.notify(
          'error',
          'Unable to accept Stripe Terms of Agreement.'
        );
      }
      // localStorage.setItem('stripeAccFlg', JSON.stringify(res));
    } catch (err) {
      console.log(err);
      this.result.emit(err);
    }
  }
}
